export enum BackgroundAdjudicationStatus {
  Engaged = 'engaged',
  Declined = 'declined',
}
